export { PaperClipAlt as default } from './PaperClipAlt';
